import { render, staticRenderFns } from "./PlatformIncome.vue?vue&type=template&id=6d65e2f4&scoped=true&"
import script from "./PlatformIncome.vue?vue&type=script&lang=js&"
export * from "./PlatformIncome.vue?vue&type=script&lang=js&"
import style0 from "./PlatformIncome.vue?vue&type=style&index=0&id=6d65e2f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d65e2f4",
  null
  
)

export default component.exports